export function getItems (details) {
  let cid = details.company_id
    let items = [
        { to: { name: 'DemandDashboard' }, label: 'Dashboard', icon: 'icon-Dashboard' },
      { to: { name: 'DemandActivity', params: { cid: cid } }, label: 'Reports', icon: 'icon-Dashboard' },
      { to: { name: 'DemandSettings', params: { cid: cid } }, label: 'Settings', icon: 'icon-Settings' },
      { to: { name: 'DemandAdReview', params: { cid: cid } }, label: 'Ad Review', icon: 'icon-Dashboard' },
      { to: { name: 'DemandExplorer' }, label: 'Explorer', icon: 'icon-Dashboard' },
      { to: { name: 'DemandScans', params: { cid } }, label: 'Scans', icon: 'icon-Dashboard' },
    ]
    return items
}



// WEBPACK FOOTER //
// ./src/demand/menuitems.js